{
    "name": "resume-app-frontend",
    "version": "1.0.175",
    "engines": {
        "node": "^20.19.0 || ^22.12.0 || >=24.15.0"
    },
    "scripts": {
        "ng": "node node_modules/@angular/cli/bin/ng",
        "start": "node --max_old_space_size=6000 node_modules/@angular/cli/bin/ng serve --proxy-config proxy.conf.json",
        "cypress": "./node_modules/.bin/cypress open",
        "build": "node --max_old_space_size=8192 node_modules/@angular/cli/bin/ng build",
        "test": "node --max_old_space_size=8192 node_modules/@angular/cli/bin/ng test",
        "lint": "npx eslint \"src/**/*.{js,jsx,ts,tsx,html}\"",
        "lint:err": "npx eslint \"src/**/*.{js,jsx,ts,tsx,html}\" --quiet",
        "lint:fix": "npx eslint \"src/**/*.{js,jsx,ts,tsx,html}\" --fix",
        "format": "npx prettier \"src/**/*.{js,jsx,ts,tsx,html,css,scss}\" --write",
        "format:windows": "git config --global core.autocrlf false && npx prettier \"src/**/*.{js,jsx,ts,tsx,html,css,scss}\" --write && git config --global core.autocrlf true",
        "e2e": "ng e2e",
        "get-version": "node get-version.js",
        "cypress:open": "cypress open",
        "cypress:run": "cypress run",
        "playwright": "playwright test",
        "playwright:ui": "playwright test --ui"
    },
    "private": true,
    "dependencies": {
        "@angular/animations": "^22.0.0",
        "@angular/cdk": "^22.0.0",
        "@angular/common": "^22.0.0",
        "@angular/compiler": "^22.0.0",
        "@angular/core": "^22.0.0",
        "@angular/forms": "^22.0.0",
        "@angular/localize": "^22.0.0",
        "@angular/material": "^22.0.0",
        "@angular/platform-browser": "^22.0.0",
        "@angular/platform-browser-dynamic": "^22.0.0",
        "@angular/router": "^22.0.0",
        "@ckeditor/ckeditor5-angular": "^11.2.0",
        "@fullcalendar/angular": "^6.1.19",
        "@fullcalendar/core": "^6.1.19",
        "@fullcalendar/daygrid": "^6.1.19",
        "@fullcalendar/list": "^6.1.19",
        "@fullcalendar/timegrid": "^6.1.19",
        "@ng-bootstrap/ng-bootstrap": "^21.0.0",
        "@ngxs/store": "^3.8.2",
        "@popperjs/core": "2.11.2",
        "@zxcvbn-ts/core": "^2.2.1",
        "@zxcvbn-ts/language-en": "^2.1.0",
        "angular-ng-autocomplete": "2.0.8",
        "angular-password-strength-meter": "^7.0.0",
        "angularx-social-login": "^4.0.1",
        "bootstrap": "^5.1.3",
        "chart.js": "^3.7.1",
        "chartjs-plugin-datalabels": "^2.0.0",
        "ckeditor5": "^48.5.0",
        "date-fns": "^2.28.0",
        "eslint-plugin-ngxs-style-guide": "^3.0.0",
        "file-saver": "^2.0.5",
        "jquery": "^3.6.0",
        "jwt-decode": "^3.1.2",
        "karma-sonarqube-unit-reporter": "0.0.23",
        "moment": "^2.29.1",
        "ng2-charts": "^3.0.8",
        "ng2-pdf-viewer": "^10.4.0",
        "ngx-chips": "^3.0.0",
        "ngx-filter-pipe": "^3.0.1",
        "ngx-google-analytics": "^13.0.1",
        "ngx-logger": "^5.0.9",
        "ngx-moment": "^6.0.2",
        "ngx-order-pipe": "^3.0.0",
        "ngx-pipes": "3.0.0",
        "ngx-toastr": "^20.0.5",
        "ngx-trim-directive": "^2.0.0",
        "rxjs": "^7.5.4",
        "sortablejs": "^1.13.0",
        "tslib": "^2.2.0",
        "validator": "^13.7.0",
        "zone.js": "~0.15.0",
        "zxcvbn3": "^0.1.1"
    },
    "devDependencies": {
        "@angular/build": "^22.1.7",
        "@angular/cli": "^22.0.0",
        "@angular/compiler-cli": "^22.0.0",
        "@angular/language-service": "^22.0.0",
        "@cypress/schematic": "^2.0.0",
        "@ngneat/spectator": "^22.1.0",
        "@ngxs/devtools-plugin": "^3.8.2",
        "@playwright/test": "^1.63.0",
        "@trivago/prettier-plugin-sort-imports": "^6.0.2",
        "@types/jasmine": "^3.7.6",
        "@types/jasminewd2": "~2.0.9",
        "@types/node": "^22.20.2",
        "@types/sortablejs": "^1.10.6",
        "angular-eslint": "^22.5.0",
        "cypress": "^16.0.0",
        "eslint": "^9.39.5",
        "eslint-config-prettier": "^10.1.8",
        "eslint-plugin-prettier": "^5.5.6",
        "eslint-plugin-unused-imports": "^4.4.1",
        "http-server": "^14.1.1",
        "istanbul-lib-instrument": "^6.0.3",
        "jasmine-core": "^7.0.2",
        "jasmine-spec-reporter": "~7.0.0",
        "karma": "^6.4.4",
        "karma-chrome-launcher": "~3.1.0",
        "karma-coverage-istanbul-reporter": "~3.0.3",
        "karma-jasmine": "~4.0.1",
        "karma-jasmine-html-reporter": "^1.6.0",
        "prettier": "^3.9.6",
        "ts-node": "~10.6.0",
        "typescript": "~6.0.3",
        "typescript-eslint": "^8.70.0"
    },
    "overrides": {
        "xlsx": "0.18.5",
        "minimatch@9": {
            "brace-expansion": "2.1.7"
        }
    }
}
